import { useMemo } from 'react';

import InnerHeaderWithIcon from '@feat/reports/components/inner-header-with-icon.renderer';

export const useDefaultColumnDefinition = () => {
  return useMemo(() => {
    return {
      filter: true,
      headerComponentParams: {
        innerHeaderComponent: InnerHeaderWithIcon,
      },
    };
  }, []);
};
